import { t } from "@/i18n-js/instance";
import { toLocaleString } from "@circle-react/helpers/number";
import { useBillingContext } from "../BillingContext";
import { UsageDetailsSection } from "./UsageDetailsSection";
import { UsageMetric } from "./UsageMetric";

const localeRoot = "settings.billing.manage_billing.usage_details.ai_actions";

export const AiActionsUsageDetails = () => {
  const { auxiliarySubscription } = useBillingContext();

  if (!auxiliarySubscription?.ai_actions?.is_active) {
    return null;
  }

  const {
    usage_count: usageCount,
    free_quantity: freeQuantity,
    progress,
    currency_symbol: currencySymbol,
    final_overage_price: overagePrice,
    overage: isOverage,
  } = auxiliarySubscription.ai_actions;

  const description = t(`${localeRoot}.credits.description`, {
    used: toLocaleString(usageCount),
    total: toLocaleString(freeQuantity),
  });

  const price = isOverage
    ? `${currencySymbol}${toLocaleString(overagePrice)}`
    : undefined;

  return (
    <UsageDetailsSection title={t(`${localeRoot}.title`)} showMenu>
      <UsageMetric
        title={t(`${localeRoot}.credits.title`)}
        progress={progress}
        description={description}
        price={price}
      />
    </UsageDetailsSection>
  );
};
